import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '🗺️',
    title: 'Mapa Rápido de Primeras 100 Señas',
    desc: 'Las 100 señas más urgentes organizadas por situación real para empezar sin confusión desde el día uno',
    value: '$8.000'
  }, {
    id: '02',
    emoji: '✅',
    title: 'Checklist de Práctica Diaria LSA en 10 Minutos',
    desc: 'La rutina simple de 30 días que convierte el aprendizaje en hábito sin depender de la motivación',
    value: '$7.000'
  }, {
    id: '03',
    emoji: '💬',
    title: 'Frases Rápidas para Situaciones Reales',
    desc: '80 frases listas para las 8 situaciones más frecuentes: calle, salud, trabajo, familia, comercio y más',
    value: '$9.000'
  }, {
    id: '04',
    emoji: '📊',
    title: 'Tracker de Avance LSA 30 Días',
    desc: 'El sistema visual de seguimiento que hace visible tu transformación para que nunca dudes de que avanzás',
    value: '$8.000'
  }];
  return <section className="py-20 bg-slate-900 text-white relative overflow-hidden" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-400/20 text-amber-400 mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-27">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-amber-400 font-bold" data-id="element-28">SIEMPRE INCLUIDOS</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-29">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-slate-800 border border-slate-700 rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-amber-500/50 transition-colors" data-id="element-30">
              <div className="absolute top-0 right-0 bg-slate-700 text-slate-400 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                Bono {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-32">
                <div className="text-4xl" data-id="element-33">{bono.emoji}</div>
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-slate-700 flex items-center justify-between" data-id="element-37">
                <span className="text-slate-500 line-through text-sm" data-id="element-38">
                  Valor {bono.value}
                </span>
                <span className="text-amber-400 font-black tracking-wide" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-40">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-8 py-4" data-id="element-41">
            <p className="text-lg" data-id="element-42">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-43">$32.000</span>{' '}
              <span className="text-amber-400 font-bold mx-2" data-id="element-44">→</span>{' '}
              <span className="font-black text-xl" data-id="element-45">GRATIS con tu MegaPack</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}